<template>
  <div
    class="row py-3 justify-content-end flex-shrink-0 idea-form"
    id="filter-div"
    style="margin-left: 20px; margin-right: 20px; margin-top: 20px"
  >
    <div id="searchContainer" class="col-12 row m-0 p-0">
      <div class="container mb-3 mw-100">
        <div class="form-group col-12 col-md-12 row">
          <div class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="searchProblemText">Fikir Numarası</label>
            </div>
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                id="suggestionNumber"
                name="suggestionNumber"
                v-model="suggestionNumber"
              />
            </div>
          </div>
          <div v-if="isForm == 'idea'" class="col-12 col-md-6 column-flex mb-3">
            <div class="col-md-4">
              <label for="searchProblemText">Anahtar Kelime</label>
            </div>
            <div class="col-md-8">
              <input
                class="form-control"
                id="searchKeywordText"
                name="KeywordText"
                type="text"
                v-model="searchKeyword"
              />
            </div>
          </div>
          <div v-if="isForm == 'idea'" class="col-12 col-md-6 column-flex">
            <div class="col-md-4">
              <label for="searchFilterStatus">Statü Seçiniz</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="suggestionStatuses"
                tag-placeholder="Add this as new tag"
                placeholder="Tümü"
                label="name"
                track-by="code"
                :options="statusOptions"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                @tag="addTag"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
              ></multiselect>
            </div>
          </div>
          <div
            v-if="isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label>Departman</label>
            </div>
            <div class="col-md-8">
              <multiselect
                v-model="departmentGeneral"
                tag-placeholder="Add this as new tag"
                placeholder="Departman seçiniz"
                label=""
                track-by=""
                :options="departmentsData"
                :searchable="true"
                :multiple="true"
                :max="1"
                style="padding: 0"
                selectLabel="Seçmek için tıklayınız"
                selectedLabel="Seçildi"
                deselectLabel="Silmek için tıklayınız"
              >
              </multiselect>
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex mb-3"
          >
            <div class="col-md-4">
              <label for="title">Proje Adı</label>
            </div>
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                id="title"
                name="title"
                v-model="title"
              />
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex"
          >
            <div class="col-md-4">
              <label for="txtProjectName">Proje Yılı</label>
            </div>
            <div class="col-md-8">
              <select
                class="form-control"
                data-val="true"
                data-val-number="The field Value must be a number."
                data-val-required="The Value field is required."
                id="drpProjectYear"
                name="ProjectYear.Value"
                v-model="projectYear"
              >
                <option
                  v-for="item in projectYearList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            v-if="isForm == 'product' || isForm == 'projectPool'"
            class="col-12 col-md-6 column-flex mb-3"
          >
            <div class="form-check form-check-inline">
              <input
                type="checkbox"
                class="form-check-input"
                id="onlyContinuityTrackingSuggestion"
                placeholder=""
                v-model="onlyContinuityTrackingSuggestion"
              />
              <label
                :for="onlyContinuityTrackingSuggestion"
                class="form-check-label"
                >Süreklilik Takibi</label
              >
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer w-100 border-0 justify-content-end">
        <b-button
          v-if="isForm == 'idea' || isForm == 'product'"
          @click="downloadExcel"
          variant="success"
          :disabled="isDownloadExcel"
        >
          <span class="mr-2">Excel İndir</span>
          <b-icon icon="download"></b-icon>
        </b-button>
        <button
          v-if="isControlBtn && isControlBtn == 'MyAssignments'"
          @click.stop="continuityTrackingList"
          type="button"
          class="btn-innovation-modal bg-primary lh-normal"
        >
          Süreklilik Takibi
        </button>
        <button
          @click="searchFilterRemoveValue"
          type="reset"
          class="btn-innovation-modal bg-orange"
        >
          Sıfırla
        </button>
        <button
          @click="searchFilter"
          type="button"
          class="btn-innovation-modal bg-orange"
        >
          Filtrele <span class="icon-arrow-right pl-2"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import { lowerCaseKeys, yearList } from "../../helpers";
import { suggestionService, suggestionRdService } from "../../services";
import Multiselect from "vue-multiselect";
import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "IdeaForm",
  data() {
    return {
      optionUsers: [],
      statusOptions: [],
      currenValuelist: [],
      selectedCompany: "",
      suggestionNumber: "",
      valueCurrentId: "",
      suggestionStatuses: [],
      createdUserId: null,
      searchKeyword: "",
      startDate: null,
      endDate: null,
      teamLeader: null,
      optionTeamLeader: [],
      valueCurrentLeader: null,
      currenValuelistLeader: [],
      title: "",
      projectYear: null,
      projectYearList: [],
      selectDecider: null,
      deciderList: [],
      evaluatorList: [],
      selectEvaluator: null,
      department: "",
      departmentGeneral: "",
      companiesList: [],
      onlyContinuityTrackingSuggestion: null,
      isDownloadExcel: false,
    };
  },
  props: {
    location: {
      type: String,
      default: "evaluation-invendo",
    },
    searchText: {
      type: String,
    },
    isIdea: {
      type: String,
    },
    isLayout: {
      type: String,
    },
    isForm: {
      type: String,
    },
    isControlBtn: {
      type: String,
    },
    suggestionTypeId: {
      type: String,
    },
    totalRecords: {
      type: Number,
    },
    isAssignToTeamLeader: {
      type: Boolean,
    },
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    getUsers() {
      return this.$store.getters["user/getUsers"];
    },
    getCompanies() {
      return this.$store.getters["suggestion/companiesData"];
    },
    gettersValueCurrents() {
      return this.$store.getters["suggestion/getValueCurrents"];
    },
    departmentsData() {
      return this.$store.getters["suggestionRD/departmentsData"];
    },
    gettersStatusByRoles() {
      return this.$store.getters["suggestion/statusByRoles"];
    },
    statusByRolesInvendo() {
      return this.$store.getters["suggestion/statusByRolesInvendo"];
    },
    statusByRolesProductization() {
      return this.$store.getters["suggestion/statusByRolesProductization"];
    },
  },
  watch: {
    getUsers: {
      handler: function (val) {
        // Return the object that changed
        val.forEach((element) => {
          this.setUsers(element);
        });
        this.selectedUser();
      },
      deep: true,
    },
  },
  async created() {
    this.projectYearList = yearList();
    await this.setSearchFilterParamsFromQuery();

    if (this.departmentsData.length == 0) {
      await this.$store.dispatch("suggestionRD/getDepartments");
    }
    if (!this.getUsers) {
      await this.$store.dispatch("user/getUsers");
    } else {
      this.getUsers.forEach((element) => {
        this.setUsers(element);
      });
    }
    this.searchKeyword = this.searchText ? this.searchText : "";
    await this.getValueCurrents();
    await this.getStatusByRoles();
    if (!this.getCompanies) await this.$store.dispatch("suggestion/setData");
    this.companiesList = [{ Id: "", Name: "Tümü" }, ...(this.getCompanies || [])];
    this.selectedUser();
    this.equalData();
  },
  methods: {
    async downloadExcel() {
      let _tmpSuggestionStatusesId = [];
      let tmpData = null;
      this.suggestionStatuses.map((i) => _tmpSuggestionStatusesId.push(i.code));
      tmpData = {
        pageSize: this.totalRecords,
        pageIndex: 0,
        suggestionNumber: this.suggestionNumber,
        companyId: this.selectedCompany,
        valueCurrentId: this.valueCurrentId,
        suggestionStatuses: _tmpSuggestionStatusesId,
        searchKeyword: this.searchKeyword,
        startDate: this.startDate,
        endDate: this.endDate,
        suggestionEvaluatorId: this.selectEvaluator
          ? this.selectEvaluator?.Id
          : null,
        suggestionDeciderId: this.selectDecider ? this.selectDecider?.Id : null,
        department: this.department ? this.department[0] : null,
        departmentGeneral: this.departmentGeneral
          ? this.departmentGeneral[0]
          : null,
        valueCurrentManagerId: this.valueCurrentLeader
          ? this.valueCurrentLeader[0]?.Id
          : null,
        title: this.title,
        projectYear: this.projectYear,
        teamLeaderId: this.teamLeader ? this.teamLeader[0]?.Id : null,
        onlyContinuityTrackingSuggestion: this.onlyContinuityTrackingSuggestion,
        createdUserId: this.isAssignToTeamLeader || this.isControlBtn == 'MyAssignments' ? 0 : this.user.Data.UserId,
        LoginUserId: this.user.Data.UserId,
        isAssignToTeamLeader: this.isAssignToTeamLeader,
      };
      this.isForm == "idea"
        ? (tmpData.suggestionTeamLeaderId = this.teamLeader?.Id
            ? this.teamLeader?.Id
            : null)
        : this.isForm == "product"
        ? (tmpData.teamLeaderId = this.teamLeader?.Id ? this.teamLeader?.Id : null)
        : "";
      this.isDownloadExcel = true;
      let res = null;
      if(this.suggestionTypeId == 1)
      {
        res = await suggestionService.fetchSuggestionDownloadExcel(tmpData);
      }
      else if ( this.suggestionTypeId == 3) {
        res = await suggestionRdService.fetchSuggestionRDDownloadExcel(tmpData);
      } 
      
      const file = `data:image/png;base64,${res.Data.DownloadBinary}`;
      const fileName = `${res.Data.Filename}${res.Data.Extension}`;
      saveAs(file, fileName);
      
      this.isDownloadExcel = false;
    },
    equateSelectedCompany() {
      if (
        this.getCompanies.length == 2 &&
        this.getCompanies[0].Id == 2 &&
        this.getCompanies[1].Id == 7
      ) {
        this.selectedCompany = "";
      } else {
        this.selectedCompany = this.user.Data.CompanyId;
      }
    },
    equalData() {
      this.equateSelectedCompany();
    },
    async getStatusByRoles() {
      if (this.suggestionTypeId == "1") {
        if (this.gettersStatusByRoles.length == 0) {
          await this.$store.dispatch("suggestion/getStatusByRoles", {
            suggestionTypeId: this.suggestionTypeId,
            companyId: this.user.Data.CompanyId,
          });
        }
        for await (const element of this.gettersStatusByRoles) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      } else if (this.suggestionTypeId == "3") {
        if (this.statusByRolesProductization.length == 0) {
          await this.$store.dispatch(
            "suggestion/getStatusByRolesProductization",
            {
              suggestionTypeId: this.suggestionTypeId,
              companyId: this.user.Data.CompanyId,
            }
          );
        }
        for await (const element of this.statusByRolesProductization) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      } else if (this.suggestionTypeId == "4") {
        if (this.statusByRolesInvendo.length == 0) {
          await this.$store.dispatch("suggestion/getStatusByRolesInvendo", {
            suggestionTypeId: this.suggestionTypeId,
            companyId: this.user.Data.CompanyId,
          });
        }
        for await (const element of this.statusByRolesProductization) {
          this.statusOptions.push({
            code: element.StatusId,
            name: element.StatusName,
          });
        }
      }
    },
    setUsers(element) {
      this.optionUsers.push({
        name: element.FullName + " (" + element.CompanyName + ")",
        code: element.Id,
      });
      this.optionTeamLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.currenValuelistLeader.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.deciderList.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
      this.evaluatorList.push({
        Name: element.FullName + " (" + element.CompanyName + ")",
        Id: element.Id,
      });
    },
    selectedUser() {
      if (this.isIdea == "my-idea" && this.isForm != "projectPool") {
        this.createdUserId = this.optionUsers.filter(
          (u) => u.code == this.user.Data.UserId
        );
      } else {
        this.createdUserId = null;
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.suggestionStatuses.push(tag);
    },
    addTagUser(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.optionUsers.push(tag);
      this.createdUserId = tag;
    },
    addTagTeamLeader(newTag) {
      const tag = {
        Name: newTag,
        Id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.teamLeader.push(tag);
      this.optionTeamLeader.push(tag);
    },
    addTagCurrentValue(newTag) {
      const tag = {
        Name: newTag,
        Id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.valueCurrentLeader.push(tag);
      this.currenValuelistLeader.push(tag);
    },
    async valueCurrentsFill() {
      if (this.gettersValueCurrents.length > 0) {
        this.currenValuelist = this.gettersValueCurrents;
      }
    },
    async getValueCurrents() {
      if (this.gettersValueCurrents.length == 0) {
        await this.$store.dispatch("suggestion/getValueCurrentsData");
      }
      await this.valueCurrentsFill();
    },
    searchFilterRemoveValue() {
      this.equateSelectedCompany();
      this.suggestionNumber = "";
      this.valueCurrentId = "";
      this.suggestionStatuses = [];
      this.createdUserId = null;
      this.searchKeyword = "";
      this.startDate = null;
      this.endDate = null;
      this.selectEvaluator = null;
      this.department = "";
      this.departmentGeneral = "";
      this.selectDecider = null;
      this.title = null;
      this.projectYear = null;
      this.teamLeader = null;
      this.valueCurrentLeader = null;
      this.onlyContinuityTrackingSuggestion = null;
      const data = {
        suggestionNumber: this.suggestionNumber,
        companyId: this.selectedCompany,
        valueCurrentId: this.valueCurrentId,
        suggestionStatuses: this.suggestionStatuses,
        searchKeyword: this.searchKeyword,
        startDate: this.startDate,
        endDate: this.endDate,
        suggestionEvaluatorId: this.selectEvaluator,
        suggestionDeciderId: this.selectDecider,
        department: this.department,
        valueCurrentManagerId: this.valueCurrentLeader,
        teamLeaderId: this.teamLeader,
        title: this.title,
        projectYear: this.projectYear,
        onlyContinuityTrackingSuggestion: this.onlyContinuityTrackingSuggestion,
      };
      this.$emit("clear-search-filter", data);
    },
    async setSearchFilterParamsFromQuery() {
      const route = lowerCaseKeys(this.$route.query);
      this.onlyContinuityTrackingSuggestion = route?.conttracking === "true";
      if (this.onlyContinuityTrackingSuggestion) await this.searchFilter();
    },
    async searchFilter() {
      let _tmpSuggestionStatusesId = [];
      let data = null;
      this.suggestionStatuses.map((i) => _tmpSuggestionStatusesId.push(i.code));
      const createdUserId = this.createdUserId ? this.createdUserId.code : null;
      data = {
        suggestionNumber: this.suggestionNumber,
        companyId: this.selectedCompany,
        valueCurrentId: this.valueCurrentId,
        suggestionStatuses: _tmpSuggestionStatusesId,
        searchKeyword: this.searchKeyword,
        startDate: this.startDate,
        endDate: this.endDate,
        suggestionEvaluatorId: this.selectEvaluator
          ? this.selectEvaluator?.Id
          : null,
        suggestionDeciderId: this.selectDecider ? this.selectDecider?.Id : null,
        department: this.department ? this.department[0] : null,
        departmentGeneral: this.departmentGeneral
          ? this.departmentGeneral[0]
          : null,
        valueCurrentManagerId: this.valueCurrentLeader
          ? this.valueCurrentLeader[0]?.Id
          : null,
        title: this.title,
        projectYear: this.projectYear,
        teamLeaderId: this.teamLeader ? this.teamLeader[0]?.Id : null,
        onlyContinuityTrackingSuggestion: this.onlyContinuityTrackingSuggestion,
      };
      this.isForm == "idea"
        ? (data.suggestionTeamLeaderId = this.teamLeader?.Id
            ? this.teamLeader?.Id
            : null)
        : this.isForm == "product"
        ? (data.teamLeaderId = this.teamLeader?.Id ? this.teamLeader?.Id : null)
        : "";
      if (this.isIdea != "my-idea") data.createdUserId = createdUserId;
      await this.$store.dispatch("ideas/setFilterIdea", data);
      await this.$emit("search-filter", data);
    },
    continuityTrackingList() {
      this.$emit("continuity-tracking-list");
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/admin/styles/scss/idea-form.scss";
</style>
